<template>
  <v-card>
    <div class="align-center d-flex justify-space-between px-2 py-2 mt-4" style="border-bottom: 1px solid #BDBDBD">
        <div class="px-4 d-flex">
            <div class="headline m-auto"
            >Đơn hàng</div
            >
        </div>
        <div class="text-right">
            <v-icon aria-label="Close" @click="$emit('close')"
            >mdi-close</v-icon
            >
        </div>
    </div>

    <div style="max-height:750px;overflow-y:auto" id="style-2">
      <div v-for="item in totalListOrder" :key="item.index">
        <template v-if="item.version === ORDER_VERSION.V1">
          <v-row
            v-if="!item.statusOrder  && !item.isGroupOrder"
            class="border mx-5 mb-3 mt-2"
            style="padding: 16px;border: 1px solid #BDBDBD; border-radius:8px"
          >
            <v-col cols="7" class="text-left font-weight-bold"
            >{{ item.code }} - {{ formatPrice(item.totalPrice) }} /
              {{ item.paymentType }} /
              {{ _.get(item, "contactStatus.type", "") }}-{{
                _.get(item, "contactStatus.name", "")
              }}</v-col
            >
            <v-col cols="5" class="text-right font-weight-bold"
            >Sale:
              {{ item.user && item.user.fullName ? item.user.fullName : "" }}</v-col
            >

            <v-row
              v-for="product in item.products"
              :key="product.index"
              class="px-2 pb-1 w-100 mb-2 pt-9"
            >
              <v-col cols="4" class="pl-0 py-0">
                <v-row>
                  <v-col cols="2" class="py-0 pr-0 text-right">
                    <v-icon class="pr-1" color="green"
                    >mdi-book-open-variant</v-icon
                    >
                  </v-col>
                  <v-col cols="10" class="py-0 text-left">{{ product.name }}</v-col>
                </v-row>
              </v-col>
              <v-col cols="1" class="pl-0 py-0">{{ product.quantity }}</v-col>
              <v-col cols="2" class="pl-0 py-0">{{
                  formatPrice(product.price)
                }}</v-col>
              <v-col cols="3" class="pl-0 py-0">{{ product.childName }}</v-col>
              <v-col cols="2" class="pl-0 py-0 text-right">{{
                  formatDateCus(item.createdAt, 'DD-MM-YYYY')
                }}</v-col>
            </v-row>

            <v-row
              v-for="combo in item.combos"
              :key="combo.index"
              class="px-2 pb-1 w-100 mb-2 pt-9"
            >
              <v-col cols="4" class="pl-0 py-0">
                <v-row>
                  <v-col cols="2" class="py-0 pr-0 text-right">
                    <v-icon class="pr-1" color="green"
                    >mdi-book-open-variant</v-icon
                    >
                  </v-col>
                  <v-col cols="10" class="py-0 text-left">{{ combo.name }}</v-col>
                </v-row>
              </v-col>

              <v-col cols="1" class="pl-0 py-0">{{ combo.quantity }}</v-col>
              <v-col cols="2" class="pl-0 py-0">{{
                  formatPrice(combo.price)
                }}</v-col>
              <v-col cols="3" class="pl-0 py-0">{{ combo.childName }}</v-col>
              <v-col cols="2" class="pl-0 py-0 text-right">
                {{ formatDateCus(item.createdAt, 'DD-MM-YYYY') }}
              </v-col>
            </v-row>
          </v-row>
          <v-row
            class="border mx-5 mb-3 mt-2"
            style="padding-top: 16px;padding-bottom: 16px;border: 1px solid #BDBDBD; border-radius:8px"
            v-if="item.isGroupOrder">
            <div class="border-order px-4" style="width: 100%">
              <v-row class="mr-1 ml-1">
                <v-col cols="8" class="text-left font-weight-bold">
                  {{ item.code }} - {{ formatPrice(item.totalPrice) }} / Đơn có
                  cọc / {{ item.depositLabel }}
                </v-col>

                <v-col cols="4" class="text-right font-weight-bold">
                  Sale:
                  {{
                    item.user && item.user.fullName
                      ? item.user.fullName
                      : ""
                  }}
                </v-col>
              </v-row>

              <v-row
                v-for="(product,index) in item.listOrders[0].products"
                class="px-2 pb-1 w-100 mb-2 pt-9"
                :key="'product'+index"
              >
                <v-col cols="4" class="pl-0 py-0">
                  <v-row>
                    <v-col cols="3" class="py-0 pr-0 text-right">
                      <v-icon class="pr-1" color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </v-col>
                    <v-col cols="9" class="py-0 text-left">{{
                        product.name
                      }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="pl-0 py-0">{{ product.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatPrice(product.intoMoney)
                  }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ product.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatDateCus(item.createdAt, 'DD-MM-YYYY')
                  }}</v-col>
              </v-row>
              <v-row v-for="(combo,index) in item.listOrders[0].combos" class="px-2 pb-1 w-100 mb-2 pt-9" :key="'combo'+index">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row>
                    <v-col cols="3" class="py-0 pr-0 text-right">
                      <v-icon class="pr-1" color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </v-col>
                    <v-col cols="9" class="py-0 text-left">{{
                        combo.name
                      }}</v-col>
                  </v-row>
                </v-col>

                <v-col cols="1" class="pl-0 py-0">{{ combo.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatPrice(combo.price)
                  }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ combo.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatDateCus(item.createdAt, 'DD-MM-YYYY')
                  }}</v-col>
              </v-row>
            </div>
            <div v-if="!item.hasFinishOrder" class="w-100 text-right mt-2 mx-3">
            <span
              @click="toOrderDetail(item.depositOrderId)"
              class="create-finish-order-btn"
            >Tạo đơn hoàn tất</span
            >
            </div>
            <div class="px-4 mx-3 pb-4 w-100" v-if="item.listOrders">
              <div
                style="width: 100%"
                v-for="(itemG, index) in item.listOrders"
                :key="index"
              >
                <div class="log-deposit font-weight-bold mt-6">
                  <div class="log-deposit-status">
                    <div
                      v-if="itemG.orderType == orderDepositType"
                      class="deposit"
                    >
                      Cọc
                    </div>
                    <div
                      v-if="itemG.orderType == orderFinishType"
                      class="deposit finished"
                    >
                      Hoàn tất
                    </div>
                  </div>
                  <div class="log-deposit-info">
                    <div class="log-deposit-name">
                      {{ itemG.code }} - {{ formatPrice(itemG.totalPrice) }} /
                      {{ itemG.paymentType }} /
                      {{ _.get(itemG, "contactStatus.type", "") }}-{{
                        _.get(itemG, "contactStatus.name", "")
                      }}
                      <v-icon
                        v-if="itemG.orderType == orderDepositType"
                        color="#219653"
                      >mdi-lock</v-icon
                      >
                    </div>
                    <div class="log-deposit-sale">
                      Sale:
                      {{
                        itemG.user && itemG.user.fullName
                          ? itemG.user.fullName
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <div class="log-deposit font-weight-bold">
                  <div class="log-deposit-status"></div>
                  <div class="log-deposit-info">
                    <div class="log-deposit-name">
                      {{
                        itemG.orderType == orderDepositType
                          ? "Tiền cọc"
                          : "Tiền hoàn tất"
                      }}
                      :
                      <b
                        :style="{
                        color:
                          itemG.orderType == orderDepositType
                            ? '#268A42'
                            : '#BD0188',
                      }"
                      >{{ formatPrice(itemG.totalPrice) }}</b
                      >
                    </div>
                    <div class="log-deposit-sale">
                      {{ formatDateCus(itemG.createdAt, 'DD-MM-YYYY') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
          <div class="transfers-order" v-if="item.statusOrder">
            <div class="transfers-order-name">
              CHUYỂN PHÍ <span>bởi {{ item.created_name }}</span>
            </div>
            <div class="transfers-order-info">
              <div class="transfers-order-item">
                <div class="my-3">
                  {{ subjectTransfer(Number(item.old_subject_type)) }} -
                  {{ typeTeacher(item.old_teacher_type) }} - 1:
                  {{ item.old_class_type }}
                </div>
                <span>{{ item.number_transfer_lesson }} buổi</span>
              </div>
              <div
                class="transfers-order-icon mt-5"
                :style="{
                background:
                  item.type == PACKAGE_FEE.GIA_SU ? '#58BFDA' : '#6A2C62',
              }"
              >
                <v-icon color="white">mdi-swap-horizontal</v-icon>
              </div>
              <div
                class="transfers-order-item ml-10"
                v-if="item.type == PACKAGE_FEE.GIA_SU"
              >
                <div class="my-3">
                  {{ subjectTransfer(Number(item.new_subject_type)) }} -
                  {{ typeTeacher(item.new_teacher_type) }} - 1:
                  {{ item.new_class_type }}
                </div>
                <span>{{ item.number_target_lesson }} buổi</span>
              </div>
              <div
                class="transfers-order-item ml-10"
                v-if="item.type == PACKAGE_FEE.TU_HOC"
              >
                <div class="my-3">GÓI TỰ HỌC</div>
                <span>{{ formatPrice(item.number_target_lesson) }} đ</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="item.version === ORDER_VERSION.V2">
          <v-row v-if="!item.statusOrder && !item.isGroupOrder"
                 class="border mx-5 mb-3 mt-2"
                 style="border: 1px solid #BDBDBD; border-radius:8px"
          >
            <v-col cols="12">
              <v-row style="background-color: #EEEEEE; border-radius: 8px 8px 0 0; border-bottom: 1px solid #BDBDBD">
                <v-col cols="7" class="text-left font-weight-bold"
                >
                  <a :href="crmOrderDetailLink(item)" target="_blank">{{ item.code }}</a>
                  - {{ formatPrice(item.totalPrice) }} /
                  {{ _.get(item, "contactStatus.type", "") }}-{{
                    _.get(item, "contactStatus.name", "")
                  }}</v-col
                >
                <v-col cols="5" class="text-right">
                  Sale:
                  {{ item.user && item.user.fullName ? item.user.fullName : "" }}
                  ({{formatDateCus(item.createdAt, 'DD-MM-YYYY')}})
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="item.products.length > 0">
              <v-row v-for="product in item.products" :key="product.index" class="px-2 pb-1 w-100 pt-4" style="padding-top: 35px;">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row class="pt-2">
                    <v-col cols="1" class="py-0 px-0 text-left pl-7">
                      <v-icon class="pr-1" color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </v-col>
                    <v-col cols="10" class="py-0 text-left pl-7 my-auto">{{ product.name }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="pl-0 py-0">{{ product.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <span v-on="on" v-bind="attrs">
                          {{formatPrice(product.intoMoney)}}
                        </span>
                    </template>
                    <span>
                        Giá gốc: {{formatPrice(product.price * product.quantity)}}
                      </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="3" class="pl-0 py-0">{{ product.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0 text-right">{{PRODUCT_COMBO_ORDER_TYPE[product.orderType]}}</v-col>
                <v-col cols="12" class="mt-1">
                  <v-row style="margin-left: 28px !important;">
                    <v-col cols="5">
                      <div class="order-detail-box">
                        <v-row>
                          <v-col cols="6" >
                            <div style="font-size: 11px; font-weight: bold; color: #666666">THỜI HẠN</div>
                            <div class="mt-2">
                                <span v-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_TUTOR">
                                  {{product.totalDuration}} buổi
                                </span>
                              <span v-else-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO && product.durationType === 'month'">
                                  {{product.totalDuration}} tháng
                                </span>
                              <span v-else-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO && product.durationType === 'day'">
                                  {{formatDateCus(product.endDate, 'DD-MM-YYYY')}}
                                </span>
                            </div>
                          </v-col>
                          <v-col cols="6" >
                            <div style="font-size: 11px; font-weight: bold; color: #666666">
                              CHÍNH SÁCH
                            </div>
                            <div class="mt-2">
                                <span v-if="product.pricePolicyDuration">
                                  Tặng thêm {{product.pricePolicyDuration}} {{product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO ? 'tháng' : 'buổi'}}
                                </span>
                              <span v-else>--</span>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="7">
                      <div class="order-detail-box">
                        <v-row>
                          <v-col cols="12" >
                            <div style="font-size: 11px; font-weight: bold; color: #666666">KHUYẾN MẠI</div>
                            <div class="mt-2">
                              <template v-if="_.size(product.campaigns) > 0">
                                <template v-for="(campaign) in product.campaigns">
                                  <div v-for="(promotion, index) in campaign.orderProductPromotions" :key="'promotion' + index">
                                    {{promotion.quantity}}x {{promotion.name}}
                                  </div>
                                </template>
                              </template>
                              <span v-else>--</span>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="item.combos.length > 0">
              <v-row v-for="combo in item.combos" :key="combo.index" class="px-2 pb-1 w-100 pt-4 mt-0" style="padding-top: 35px;">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row class="pt-2">
                    <v-col cols="1" class="py-0 px-0 text-left pl-7">
                      <v-icon color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </v-col>
                    <v-col cols="10" class="py-0 pl-7 text-left my-auto">{{ combo.name }}</v-col>
                  </v-row>
                </v-col>

                <v-col cols="1" class="pl-0 py-0">{{ combo.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <span v-on="on" v-bind="attrs">
                          {{formatPrice(combo.intoMoney)}}
                        </span>
                    </template>
                    <span>
                        Giá gốc: {{formatPrice(combo.price * combo.quantity)}}
                      </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="3" class="pl-0 py-0">{{ combo.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0 text-right">{{PRODUCT_COMBO_ORDER_TYPE[combo.orderType]}}</v-col>
                <v-col cols="12">
                  <v-row style="margin-left: 28px">
                    <v-col cols="12">
                      <div class="order-detail-box">
                        <v-row>
                          <v-col cols="7">
                            <div style="font-size: 11px; font-weight: bold; color: #666666; margin-bottom: 8px">SẢN PHẨM TRONG COMBO</div>
                            <div v-for="(product, index) in combo.products" :key="'product-combo-name-' + index" class="mb-1">
                              {{product.name}}
                            </div>
                          </v-col>
                          <v-col cols="2">
                            <div style="font-size: 11px; font-weight: bold; color: #666666; margin-bottom: 8px">THỜI HẠN</div>
                            <div v-for="(product, index) in combo.products" :key="'product-combo-time' + index" class="mb-1">
                                  <span v-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_TUTOR">
                                  {{product.totalDuration}} buổi
                                  </span>
                              <span v-else-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO && product.durationType === 'month'">
                                  {{product.totalDuration}} tháng
                                  </span>
                              <span v-else-if="product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO && product.durationType === 'day'">
                                  {{formatDateCus(product.endDate, 'DD-MM-YYYY')}}
                                  </span>
                              <span v-else>--</span>
                            </div>
                          </v-col>
                          <v-col cols="3">
                            <div style="font-size: 11px; font-weight: bold; color: #666666; margin-bottom: 8px">CHÍNH SÁCH</div>
                            <div>
                              <div v-for="(product, index) in combo.products" :key="'product-combo-promotion' + index" class="mb-1">
                                    <span v-if="product.pricePolicyDuration">
                                      Tặng thêm {{product.pricePolicyDuration}} {{product.productType === PRODUCT_TRIAL_TYPE.SKU_DUO ? 'tháng' : 'buổi'}}
                                    </span>
                                <span v-else>--</span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <div class="order-detail-box">
                        <v-row>
                          <v-col cols="7">
                            <div style="font-size: 11px; font-weight: bold; color: #666666; margin-bottom: 8px">KHUYẾN MẠI</div>
                            <div class="mt-2">
                              <template v-if="_.size(combo.campaigns) > 0">
                                <template v-for="(campaign) in combo.campaigns">
                                  <div v-for="(promotion, index) in campaign.orderProductPromotions" :key="'promotion' + index">
                                    {{promotion.name}}
                                  </div>
                                </template>
                              </template>
                              <span v-else>--</span>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="item.version === ORDER_VERSION.V2">
              <v-row class="px-2">
                <v-col cols="12">
                  <div style="width: 100%; height: 1px; background: #BDBDBD;"></div>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <div class="d-flex font-weight-bold" style="color: #666666">
                    LỊCH SỬ THANH TOÁN
                  </div>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <div class="d-flex justify-end font-weight-bold">
                    Tổng tiền đã thanh toán: {{item.paidAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
                  </div>
                </v-col>
                <v-col cols="12" v-if="item.receipts && item.receipts.length > 0">
                  <v-row v-for="(receipt, index) in item.receipts" :key="'receipt' + index">
                    <v-col cols="9" class="pt-0">
                      <div class="d-flex align-center">
                        <div
                          v-if="ORDER_RECEIPT_STATUS_MAP.find((e) => e.value === receipt.status)"
                          class="receipt-status-box mr-3"
                          :class="ORDER_RECEIPT_STATUS_MAP.find((e) => e.value === receipt.status).styleClass">
                          {{ORDER_RECEIPT_STATUS_MAP.find((e) => e.value === receipt.status).text}}
                        </div>
                        <div class="font-weight-bold text-left" style="line-height: 1.4">
                          {{formatDateCus(receipt.created_at, 'HH:mm:ss DD/MM/YYYY')}} /
                          {{receipt.code}} - {{receipt.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}} /
                          {{receipt.payment_method}}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3" class="pt-0">
                      <div class="text-right pr-2" style="line-height: 1.4">
                        Sale: {{receipt.user ? receipt.user.fullName : ''}}
                      </div>
                    </v-col>
                    <v-col cols="12" class="pt-0 mt-3" v-if="receipt.orderProductTrials && receipt.orderProductTrials.length > 0">
                      <v-row
                        v-for="(trial, index) in receipt.orderProductTrials"
                        :key="'trial' + index"
                        class="px-2">
                        <v-col cols="4" class="pt-0">
                          {{trial.name}}
                        </v-col>
                        <v-col cols="4" class="pt-0 d-flex justify-center">
                          <template v-if="trial.productType !== PRODUCT_TRIAL_TYPE.SKU_COMBO">Quy đổi: {{trial.trailLessons}} {{trial.productType == PRODUCT_TRIAL_TYPE.SKU_DUO ? '(tháng)' : '(buổi)'}}</template>
                          <template v-else>--</template>
                        </v-col>
                        <v-col cols="4" class="pt-0 text-right">
                          Tiền quy đổi: {{trial.money && trial.money !== 0 ? trial.money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'}}
                        </v-col>
                        <template v-if="trial.productType === PRODUCT_TRIAL_TYPE.SKU_COMBO">
                          <v-col cols="12">
                            <v-row v-for="(itemCombo, index) in trial.items" :key="'itemCombo' + index">
                              <v-col cols="4" class="pl-4 pt-0 d-flex">
                                <v-icon>mdi-circle-small</v-icon>
                                <div>{{itemCombo.name}}</div>
                              </v-col>
                              <v-col cols="4" class="d-flex justify-center pt-0">Quy đổi: {{itemCombo.trailLessons}} {{itemCombo.productType === PRODUCT_TRIAL_TYPE.SKU_TUTOR ? '(buổi)' : '(tháng)'}}</v-col>
                              <v-col cols="4" class="d-flex justify-end pt-0">Tiền quy đổi: {{formatPrice(itemCombo.money)}}</v-col>
                            </v-row>
                          </v-col>
                        </template>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-else class="pt-0">
                  <span style="font-style: italic; color: #666666">Hiện tại chưa có giao dịch thanh toán nào đã/đang được xử lý</span>
                </v-col>
                <v-col cols="12" class="text-left pt-0" v-if="item.contactStatus && ( item.contactStatus.code === 'T_DATT1P' || item.contactStatus.code === 'C_DATT1P')">
                  <v-btn
                    outlined
                    color="#2196F3"
                    small
                    @click="handleRedirectOrder(item)"
                    style="text-transform: none"
                  >
                    <v-icon left>
                      mdi-plus
                    </v-icon>
                    Thanh toán thêm
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            class="border mx-5 mb-3 mt-2"
            style="padding: 16px;border: 1px solid #BDBDBD; border-radius:8px"
            v-if="item.isGroupOrder"
          >
            <div class="border-order px-3 py-2" style="width: 100%; padding-bottom: 20px !important;">
              <v-row class="mr-1">
                <v-col cols="8" class="text-left font-weight-bold">
                  {{ item.code }} - {{ formatPrice(item.totalPrice) }} / Đơn có
                  cọc / {{ item.depositLabel }}
                </v-col>

                <v-col cols="4" class="text-right font-weight-bold" style="padding-right:0px">
                  Sale:
                  {{
                    item.user && item.user.fullName
                      ? item.user.fullName
                      : ""
                  }}
                </v-col>
              </v-row>

              <v-row
                v-for="(product,index) in item.listOrders[0].products"
                class="px-2 pb-1"
                :key="'product'+index"
              >
                <v-col cols="4" class="pl-0 py-0">
                  <div class="d-flex">
                    <div class="py-0 pr-0 text-right">
                      <v-icon class="pr-1" color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </div>
                    <div class="d-flex py-0 text-left pl-3"> <div class="m-auto">{{
                        product.name
                      }}</div></div>
                  </div>
                </v-col>
                <v-col cols="1" class="pl-0 py-0">{{ product.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatPrice(product.intoMoney)
                  }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ product.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0 text-right">{{
                    formatDateCus(item.createdAt, 'DD-MM-YYYY')
                  }}</v-col>
              </v-row>
              <v-row v-for="(combo,index) in item.listOrders[0].combos" class="px-2 pb-1" :key="'combo'+index">
                <v-col cols="4" class="pl-0 py-0">
                  <v-row class="pt-2">
                    <v-col cols="2" class="py-0 pr-0 text-right pl-7">
                      <v-icon class="pr-1" color="green"
                      >mdi-book-open-variant</v-icon
                      >
                    </v-col>
                    <v-col cols="10" class="py-0 text-left pl-7 my-auto">{{
                        combo.name
                      }}</v-col>
                  </v-row>
                </v-col>

                <v-col cols="1" class="pl-0 py-0">{{ combo.quantity }}</v-col>
                <v-col cols="2" class="pl-0 py-0">{{
                    formatPrice(combo.price)
                  }}</v-col>
                <v-col cols="3" class="pl-0 py-0">{{ combo.childName }}</v-col>
                <v-col cols="2" class="pl-0 py-0 text-right">{{
                    formatDateCus(item.createdAt, 'DD-MM-YYYY')
                  }}</v-col>
              </v-row>
            </div>
            <div v-if="!item.hasFinishOrder" class="ml-2 mt-2 w-100 text-right">
                <span
                  @click="toOrderDetail(item.depositOrderId)"
                  class="create-finish-order-btn mr-3"
                >Tạo đơn hoàn tất</span
                >
            </div>
            <div class="ml-2 mb-3 w-100" v-if="item.listOrders">
              <div
                style="width: 100%"
                v-for="(itemG, index) in item.listOrders"
                :key="index"
              >
                <div class="log-deposit font-weight-bold mt-2">
                  <div class="log-deposit-status">
                    <div
                      v-if="itemG.orderType == orderDepositType"
                      class="deposit"
                    >
                      Cọc
                    </div>
                    <div
                      v-if="itemG.orderType == orderFinishType"
                      class="deposit finished"
                    >
                      Hoàn tất
                    </div>
                  </div>
                  <div class="log-deposit-info">
                    <div class="log-deposit-name">
                      {{ itemG.code }} - {{ formatPrice(itemG.totalPrice) }} /
                      {{ itemG.paymentType }} /
                      {{ _.get(itemG, "contactStatus.type", "") }}-{{
                        _.get(itemG, "contactStatus.name", "")
                      }}
                      <v-icon
                        v-if="itemG.orderType == orderDepositType"
                        color="#219653"
                      >mdi-lock</v-icon
                      >
                    </div>
                    <div class="log-deposit-sale">
                      Sale:
                      {{
                        itemG.user && itemG.user.fullName
                          ? itemG.user.fullName
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <div class="log-deposit font-weight-bold">
                  <div class="log-deposit-status"></div>
                  <div class="log-deposit-info">
                    <div class="log-deposit-name">
                      {{
                        itemG.orderType == orderDepositType
                          ? "Tiền cọc"
                          : "Tiền hoàn tất"
                      }}
                      :
                      <b
                        :style="{
                            color:
                              itemG.orderType == orderDepositType
                                ? '#268A42'
                                : '#BD0188',
                          }"
                      >{{ formatPrice(itemG.totalPrice) }}</b
                      >
                    </div>
                    <div class="log-deposit-sale" style="font-weight: 400">
                      {{ formatDateCus(itemG.createdAt, 'DD-MM-YYYY') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
          <div class="transfers-order" v-if="item.statusOrder">
            <div class="transfers-order-name">CHUYỂN PHÍ <span>bởi {{item.created_name}}</span></div>
            <div class="transfers-order-info">
              <div class="transfers-order-item">
                <div class="my-3">{{subjectTransfer(Number(item.old_subject_type))}} - {{typeTeacher(item.old_teacher_type)}} - 1: {{item.old_class_type}}</div>
                <span>{{item.number_transfer_lesson}} buổi</span>
              </div>
              <div  class="transfers-order-icon mt-5" :style="{background: item.type == PACKAGE_FEE.GIA_SU  ? '#58BFDA' : '#6A2C62'}"><v-icon color="white">mdi-swap-horizontal</v-icon></div>
              <div class="transfers-order-item  ml-10" v-if="item.type == PACKAGE_FEE.GIA_SU ">
                <div class="my-3">{{subjectTransfer(Number(item.new_subject_type))}} - {{typeTeacher(item.new_teacher_type)}} - 1: {{item.new_class_type}}</div>
                <span>{{item.number_target_lesson}} buổi</span>
              </div>
              <div class="transfers-order-item ml-10" v-if="item.type == PACKAGE_FEE.TU_HOC ">
                <div class="my-3">GÓI TỰ HỌC</div>
                <span>{{formatPrice(item.number_target_lesson)}} đ</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import { PRODUCT_COMBO_ORDER_TYPE, PRODUCT_TRIAL_TYPE } from '@/modules/student_care/constant/constant';
import { ORDER_RECEIPT_STATUS_MAP } from '@/modules/student_detail_bt/constant';
import {
  SUBJECTS_SORT_CLASS, LOAI_GIAOVIEN, PACKAGE_FEE, ORDER_DEPOSIT_TYPE, ORDER_FINISH_TYPE, ORDER_VERSION,
} from '@/helpers/constant';

export default {
  props: ['totalListOrder'],
  data() {
    return {
      PRODUCT_COMBO_ORDER_TYPE,
      PRODUCT_TRIAL_TYPE,
      ORDER_VERSION,
      ORDER_RECEIPT_STATUS_MAP,
      SUBJECTS_SORT_CLASS,
      LOAI_GIAOVIEN,
      PACKAGE_FEE,
      orderDepositType: ORDER_DEPOSIT_TYPE,
      orderFinishType: ORDER_FINISH_TYPE,
    };
  },
  methods: {
    crmOrderDetailLink(item) {
      return `${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`;
    },
    handleRedirectOrder(item) {
      window.open(`${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`, '_blank');
    },
    subjectTransfer(id) {
      let subject;
      /* eslint-disable */
      SUBJECTS_SORT_CLASS.map((s) => {
        if(s.id === id) {
          return subject = s.name
        }
      })
      /* eslint-enable */
      return subject;
    },
    typeTeacher(id) {
      let typeTeacher;
      /* eslint-disable */
      LOAI_GIAOVIEN.map((s) => {
        if(s.id === id) {
            return typeTeacher = s.name
        }
      })
      /* eslint-enable */
      return typeTeacher;
    },
    toOrderDetail(id) {
      if (!id) {
        return;
      }
      const routeData = `${process.env.VUE_APP_CRM}/order-detail/${id}?codeOrder=2`;
      window.open(routeData, '_blank');
    },
  },
};

</script>
<style lang="scss" scoped>
.transfers-order {
    background: #F1F7FF;
    margin: 16px 16px 26px 16px;
    border-radius: 6px;
    padding: 12px;
    .transfers-order-name {
    color: black;
    font-weight: 700;
    text-align: left;
    span {
        color: #828282;
        }
    }
    .transfers-order-info {
        display: flex;
        width: 100%;
        text-align: left;
        .transfers-order-item {
            color: #6A2C62;
            font-weight: 700;
            width: 50%;
            span {
                color: #333333;
            }
        }
        .transfers-order-icon {
            width: 23px;
            height: 23px;
            text-align: center;
            background: #6A2C62;
        }
    }
}
.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.level-sort {
  background: linear-gradient(147.14deg, #ff3b3b 6.95%, #6600cc 93.05%);
  border-radius: 100px;
  width: 78px;
  height: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #ffffff;
  white-space: nowrap;
  padding: 0 4px;
}
.deposit {
  background: #268a42;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  width: 65px;
  text-align: center;
}
.deposit.finished {
  background: #6a2c62;
}
.log-deposit {
  display: flex;
}
.log-deposit-status {
  width: 85px;
}
.log-deposit-info {
  display: flex;
  width: calc(100% - 85px);
  justify-content: space-between;
}
.create-finish-order-btn {
  display: inline-block;
  padding: 0px 15px;
  background: #2f80ed;
  border-radius: 3px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}
</style>
<style lang="scss">
#style-2::-webkit-scrollbar-track {
-webkit-box-shadow: inset 0 0 4px rgba(0,0,0, 0.02);
border-radius: 2px;
background-color: #FFF;
}

#style-2::-webkit-scrollbar
{
width: 5px;
background-color: #fff;
}

#style-2::-webkit-scrollbar-thumb
{
border-radius: 2px;
-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
background-color: #D9D9D9;
}

#style-3::-webkit-scrollbar-track:horizontal  {
-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
border-radius: 8px;
background-color: #fff;
}

#style-3::-webkit-scrollbar
{
height: 5px;
background-color: #fff;
}
#style-3:hover {
  &::-webkit-scrollbar {
    height: 10px !important;
    background-color: #fff;
  }
}
#style-3::-webkit-scrollbar-thumb
{
border-radius: 8px;
-webkit-box-shadow: inset 0 0 4px rgba(0,0,0, 0.02);
background-color: #D9D9D9;
}

.receipt-status-box {
  display: flex;
  justify-content: center;
  min-width: 105px;
  color: white;
  width: fit-content;
  padding: 0px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 2;
  white-space: nowrap;
}
.receipt-status-box.success {
  background: #279600;
}
.receipt-status-box.primary {
  background-color: #184BFF !important;
}
.order-detail-box {
  padding: 12px 12px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  height: 100%;
}
</style>
